// extracted by mini-css-extract-plugin
export default {"placeHolder":"builder-placeholder_placeHolder__nvTum"};